import { createSlice } from '@reduxjs/toolkit';
import { fetchCommunityData} from '../CommunityAPI/communityApi';

const communitySlice = createSlice({
  name: 'community',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchCommunityData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCommunityData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default communitySlice.reducer;
